import type {MemberTeamDTO} from "../types/teamMember.dto";
import type {MemberTeam} from "@atg-tillsammans/types";

const toMemberTeam = (team: MemberTeamDTO): MemberTeam => ({
    ...team,
    // Overrides
    captain: team.captain,
    activatedRoundsAmount: team.activatedRoundsAmount ?? undefined,
    memberAmount: team.memberAmount ?? undefined,
    pendingRequests: team.pendingRequests ?? undefined,
    unreadComments: team.unreadComments ?? undefined,
});

const toMemberTeamWithMemberId =
    (memberId?: number) =>
    (team: MemberTeamDTO): MemberTeam =>
        memberId !== undefined
            ? {
                  ...toMemberTeam(team),
                  isTeamCaptain: team.captain === memberId,
              }
            : toMemberTeam(team);

const toMemberTeamDTO = (team: MemberTeam): MemberTeamDTO => ({
    __typename: "MemberTeam",
    ...team,
    // Overrides
    captain: team.captain,
    activatedRoundsAmount: team.activatedRoundsAmount ?? null,
    memberAmount: team.memberAmount ?? null,
    pendingRequests: team.pendingRequests ?? null,
    unreadComments: team.unreadComments ?? null,
});

export const MemberTeamMapper = {
    toMemberTeam,
    toMemberTeamWithMemberId,
    toMemberTeamDTO,
};
